export const TEAM_COLORS = {
  1: "#ff0000",
  2: "#ffb400",
  3: "#00c6ff",
  4: "#c3ff00",
  5: "#ff6600",
  6: "#ac40ff",
  7: "#00ffba",
  8: "#1c47ff",
  9: "#ff2dd5",
  10: "#48ff00",
};

export const TEAM_COLOR_NAME = {
  1: "红",
  2: "黄",
  3: "天蓝",
  4: "荧光绿",
  5: "橙",
  6: "紫",
  7: "青",
  8: "蓝",
  9: "粉",
  10: "草绿",
};
